<template>
  <div class="table-responsive my-3">
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :searchable="true"
      :withCard="true"
      trackBy="geofenceId"
      :customButton="true"
      :hasDelete="false"
      :refreshData="refreshData"
      @handleSelectValue="handleSelected"
    >
      <template #title>
        <h4 class="card-title">
          {{ $t('setting.list.company.listAddress') }}
        </h4>
      </template>

      <template #button-header>
        <div class="d-flex justify-content-end">
          <McButton
            v-if="selectedIds.length > 0"
            variant="secondary-red"
            :text="$t('global.delete')"
            icon="icon-outline_trash"
            class="mx-2 mb-2"
            @click="openModalDelete"
          />
          <McButton
            v-if="hasAccess(['geofences:read', 'company:update'])"
            variant="primary"
            class="mb-2"
            :text="$t('global.addField')"
            icon="icon-fill_plus"
            @click="goToCompanyAddressForm()"
          />
        </div>
      </template>
      <template #cell(fenceName)="data">
        <a href="javascript:void(0)" @click="onRowAddressClicked(data.item)">
          <strong class="text-primary">
            {{ data.item.fenceName }}
          </strong>
        </a>
      </template>
    </McGrapqlTable>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      id="modal-delete"
      class="mc-modal"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item v-for="address in deleteAddress" :key="address.geofenceId">
            {{ address.fenceName }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton variant="secondary" :text="$t('global.no')" class="me-2" @click="cancel()" />
            <McButton variant="primary" :text="$t('global.yes')" @click="toDeleteAddress" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { DELETE_ADDRESS, GET_ADDRESS, GET_DETAIL_ADDRESS } from '@/services/api/master/address'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    McGrapqlTable,
    McButton,
  },

  props: {
    resetModal: {},
  },

  data() {
    return {
      selectedIds: [],
      deleteAddress: [],
      refreshData: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          key: 'fenceName',
          label: this.$t('master.form.address.name'),
          sortable: true,
          thStyle: 'width: 250px',
        },
        {
          key: 'category',
          label: this.$t('master.form.address.category'),
          sortable: true,
          thStyle: 'width: 250px',
        },
        {
          key: 'address',
          label: this.$t('master.form.address.fullAddress'),
          sortable: true,
          thStyle: 'width: 250px',
        },
        {
          key: 'province',
          label: this.$t('master.list.address.province'),
          sortable: true,
          thStyle: 'width: 250px',
        },
        {
          key: 'city',
          label: this.$t('master.list.address.city'),
          sortable: true,
          thStyle: 'width: 250px',
        },
      ]
    },

    query() {
      return {
        get: async (opts) => {
          const res = await this.$apollo.query({
            query: GET_ADDRESS,
            fetchPolicy: 'no-cache',
            variables: {
              isCustomer: false,
              filter: {
                search: opts.search,
                pagination: {
                  page: opts.pagination.page,
                  show: opts.pagination.show,
                },
              },
            },
          })

          return res.data.geofences.geofences
        },
      }
    },
  },

  methods: {
    goToCompanyAddressForm() {
      this.$store.commit('masterAddress/SET_STATUS', 'company')
      this.$router.push({ name: 'Company Profile Address' })
    },
    onRowAddressClicked(item) {
      if (!this.hasAccessAll(['geofences:read', 'company:update'])) return
      this.$store.commit('masterAddress/SET_STATUS', 'company')
      this.$router.push({
        name: 'Company Profile Address Update',
        params: { id: item.geofenceId },
      })
    },
    openModalDelete() {
      const selectedIds = []

      for (let i = 0; i < this.selectedIds.length; i++) {
        this.$apollo
          .query({
            query: GET_DETAIL_ADDRESS,
            variables: {
              filter: {
                geofenceId: parseInt(this.selectedIds[i]),
              },
            },
          })
          .then((res) => {
            let isSuccessful = res.data.geofence.isSuccessful
            if (isSuccessful) {
              selectedIds.push(res.data.geofence.geofence)
            }
          })
      }

      this.$emit('updateDelete', selectedIds)
      this.deleteAddress = selectedIds
      this.$bvModal.show('modal-delete')
    },
    handleSelected(value) {
      this.selectedIds = Object.keys(value)
        .filter((id) => value[id])
        .map(Number)
    },

    toDeleteAddress(bvModalEvent) {
      bvModalEvent.preventDefault()

      let promises = []
      for (let i = 0; i < this.selectedIds.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_ADDRESS,
            variables: {
              input: {
                geofenceId: this.selectedIds[i],
              },
            },
          })
        )
      }

      Promise.all(promises)
        .then((res) => {
          let failed = 0
          res.forEach((item) => {
            if (!item.data.deleteGeofence.isSuccessful) {
              this.$mcToast.error(item.data.deleteGeofence.message)
              failed++
            }
          })
          if (res.length > failed) {
            this.$mcToast.success(this.$t('global.alert.text.delete'))
          }
          this.refreshData = true
          this.$emit('clearDelete', 'address')
          this.$bvModal.hide('modal-delete')
          this.selectedIds = []
          setTimeout(() => {
            this.refreshData = false
          }, 500)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
